import { render } from "./TierView.vue?vue&type=template&id=9179729e"
import script from "./TierView.vue?vue&type=script&lang=js"
export * from "./TierView.vue?vue&type=script&lang=js"

import "./TierView.vue?vue&type=style&index=0&id=9179729e&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__